import { UUID } from "crypto";

import { baseApi } from "./baseApi";
import { Pep } from "@interfaces/peps";
import { Response, ResponsePagination } from "@interfaces/response";

const pepsApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getPeps: build.query<Array<Pep>, string>({
            query: (params) => ({
                url: `peps?${params}`,
                // params: {
                //   size: 100,
                // },
            }),
            transformResponse: (response: ResponsePagination<Pep>) => {
                return response.data.data;
            },
        }),
        getPep: build.query<Pep, UUID>({
            query: (pepId) => ({
                url: `peps/${pepId}`,
            }),
            transformResponse: (response: Response<Pep>) => {
                return response.data;
            },
        }),
        postPep: build.mutation<void, any>({
            query: (body) => ({
                method: "POST",
                url: `peps`,
                body: body,
            }),
        }),
        deletePep: build.mutation<void, UUID>({
            query: (pepId) => ({
                method: "DELETE",
                url: `peps/${pepId}`,
            }),
        }),
        patchPep: build.mutation<void, { pepId: UUID; body: any }>({
            query: ({ pepId, body }) => ({
                method: "PATCH",
                url: `peps/${pepId}`,
                body: body,
            }),
        }),
    }),
});

export const {
    useLazyGetPepsQuery,
    useLazyGetPepQuery,
    useDeletePepMutation,
    usePatchPepMutation,
    usePostPepMutation,
} = pepsApi;
